import Route from "@ember/routing/route";
import { service } from "@ember/service";

export default class ServerVolumesRoute extends Route {
  @service router;

  buildRouteInfoMetadata() {
    return { jumpable: true };
  }

  beforeModel() {
    const { server } = this.modelFor("server");

    if (!server.supportsBlockStorage) {
      this.router.replaceWith("not-found", "server");
    }
  }

  async model() {
    const { project, server } = this.modelFor("server");
    const projectVolumes = await project.blockStorageVolumes;

    return { project, server, projectVolumes };
  }
}
